import type { FC } from "react";
import AddDMSContent from "@/components/MediaSelector/forms/AddDMSContent";
import MediaType from "@/declarations/models/MediaType";
import type { AddMediaContentProps } from "@/components/MediaSelector/AddMediaModal";

export const AddImageMedia: FC<AddMediaContentProps> = ({ value, onCancel, onMediaSaved, ownerId, instanceId }) => (
  <AddDMSContent
    allowedMediaTypes={[MediaType.IMAGE]}
    media={value ?? null}
    onMediaSaved={onMediaSaved}
    onCancel={onCancel}
    ownerId={ownerId}
    instanceId={instanceId}
  />
);

export default AddImageMedia;
